













export default {
  name: 'DailyCheckInDisclaimer'
};
